module.exports = __webpack_public_path__ + "img/益视说明书_07.aa1baa87.png";